import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
export const createSkuConfigSyncPolicy = (
  backend: ClientLibraryType,
  accountId: string
): Policy<AccountState, AccountCommand> => ({
  name: 'sku-config-sync',

  init: ({ dispatch }) => {
    ( async () => {
      try {
        const config = await backend.queries.ItemsPublishingAccountConfigurationReadmodelById( accountId );

        const overrides: Record<string, string> = {};
        if ( config?.skuFormulaOverrides ) {
          const raw = config.skuFormulaOverrides as Record<string, string>;
          for ( const [ categoryId, formula ] of Object.entries( raw )) {
            overrides[categoryId] = formula;
          }
        }

        dispatch(
          {
            type: 'account/skuConfig/setData',
            payload: { categories: [], overrides }
          },
          { source: 'api' }
        );
      } catch ( error ) {
        console.error( '[account] sku-config-sync error:', error );
      }
    })();
  }
});
